import React from "react";
import { Avatar as MUIAvatar } from "@mui/material";
import styled from "styled-components";

const styles = ({ size }) => `
  height: ${sizes[size] ?? size}px !important;
  width: ${sizes[size] ?? size}px !important;
  font-size: ${(sizes[size] ?? size) / 2}px !important;
  display: inline-flex !important;
  color: #444 !important;
  .MuiAvatar-img {
    width: 100% !important;
    height: 100% !important;
  }
`;
const StyledMUIAvatar = styled(MUIAvatar)(styles);

export const sizes = {
  "x-large": 120,
  large: 80,
  medium: 56,
  small: 40,
  "x-small": 24,
};

const Avatar = ({
  size = "medium",
  title = "Avatar",
  src,
  alt,
  label,
  className,
}) => {
  // note: className is needed for nested styles with styled components
  return (
    <StyledMUIAvatar {...{ size, title, src, alt, className }}>
      {label}
    </StyledMUIAvatar>
  );
};

export default Avatar;
